import { connectionContext } from "../connection/schema";
import { BodyWidget } from "../treeBlock/components/BodyWidget/BodyWidget";
import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";

import { Card } from "@material-ui/core";
import { treeBlockContext, treeBlockOutputsContext } from "../treeBlock/schema";
import { CreateTreeEngine } from "../TreeService";

export const TreeView = observer(() => {
  const treeBlock = useContext(treeBlockContext);
  const connections = useContext(connectionContext);
  const outputs = useContext(treeBlockOutputsContext);
  useEffect(() => {
    treeBlock.getTreeStructure();
    return () => treeBlock.resetTreeStructure();
  }, [treeBlock]);
  const treeEngine = CreateTreeEngine(treeBlock, connections, outputs);

  return (
    <Card>
      <BodyWidget treeEngine={treeEngine} dataSource={treeBlock} />
    </Card>
  );
});
